// extracted by mini-css-extract-plugin
export default {"base":"link-module--base--InabM","underline":"link-module--underline--bsyQo","colorInherit":"link-module--color-inherit--Z9-O+"};